enum FitAssistantRooftopTentStatus {
  Confirmed,
  NoFit,
  Unconfirmed,
}

export default FitAssistantRooftopTentStatus;
